module.exports = __webpack_public_path__ + "static/media/audio_wave.ed75f1f3.gif";